import React from 'react';
import { Badge, Button } from 'reactstrap';

function FilterChip({ label, onRemove }) {
  return (
    <Badge color="light" className="text-dark d-inline-flex align-items-center me-1 mb-1">
      {label}
      <button
        type="button"
        className="btn-close btn-close-sm ms-1"
        aria-label={`Remove ${label}`}
        onClick={onRemove}
      />
    </Badge>
  );
}

export default function FilterChips({
  filters,
  onClearSearch,
  onClearStatus,
  onClearDateFrom,
  onClearDateTo,
  onClearAll,
}) {
  const { search, statuses, dateFrom, dateTo } = filters;
  const hasAny = search || (statuses && statuses.length > 0) || dateFrom || dateTo;
  if (!hasAny) return null;

  return (
    <div className="d-flex flex-wrap align-items-center mb-2">
      {search && (
        <FilterChip label={`Search: "${search}"`} onRemove={onClearSearch} />
      )}
      {statuses && statuses.map((s) => (
        <FilterChip key={s} label={`Status: ${s}`} onRemove={() => onClearStatus(s)} />
      ))}
      {dateFrom && (
        <FilterChip label={`From: ${dateFrom}`} onRemove={onClearDateFrom} />
      )}
      {dateTo && (
        <FilterChip label={`To: ${dateTo}`} onRemove={onClearDateTo} />
      )}
      {onClearAll && (
        <Button color="link" size="sm" className="p-0 ms-1" onClick={onClearAll}>
          Clear all
        </Button>
      )}
    </div>
  );
}
